// Module
var code = "<template> <require from=\"app/ext/iccc/assessment-attachment\"></require> <section> <assessment-attachment attachment-id.bind=\"attachmentId\" config.bind=\"assessmentConfig\" readonly.bind=\"readonly\" assessment-complete.delegate=\"router.navigateBack()\" mode=\"careplan\"> </assessment-attachment> </section> </template> ";
// Exports
module.exports = code;